import { DataSource, Question, QuestionResponse } from "./models";
import DocumentComponent from "./ResponseComponents/DocumentComponent";
import DefaultResponseComponent from "./ResponseComponents/DefaultResponseComponent";
import RadioButtonResponseComponent from "./ResponseComponents/RadioButtonResponseComponent";
import CheckboxResponseComponent from "./ResponseComponents/CheckboxResponseComponent";
import DateResponseComponent from "./ResponseComponents/DateResponseComponents";
import LicensingInfoComponent from "./ResponseComponents/LicensingInfoComponent";
import StateWideDataInfoComponent from "./ResponseComponents/StatewideDataInfoComponent";
import CommonTableComponent from "./CommonTableComponent";


// This should probably be split into multiple components
export default function QuestionInfoComponent({ question, downLoadProviderDataByDataSource }: { question: Question, downLoadProviderDataByDataSource: (dataSource: string) => void }) {


    const getResponseComponent = (response: QuestionResponse[]) => {
        response = response.sort((a, b) => (a?.propertySequence ?? 0) - (b?.propertySequence ?? 0))
        if (question.dataFieldType === 'document') {
            return <DocumentComponent response={response} />
        }
        else if (question.dataFieldType === 'radio button') {
            return <RadioButtonResponseComponent response={response} />
        }
        else if (question.dataFieldType === 'checkbox') {
            return <CheckboxResponseComponent response={response} />
        }
        else if (question.dataFieldType === 'table dynamic') {
            return <CommonTableComponent response={response} isDynamic={true} />
        }
        else if(question.dataFieldType.includes('table')){
            return <CommonTableComponent response={response} isDynamic={false}/>
        }
        else if(question.dataFieldType.includes('table with radio button')){
            return <CommonTableComponent response={response} isDynamic={false} isCheckbox={true}/>
        }
        else if (question.dataFieldType?.startsWith('date-')) {
            let tokens = question.dataFieldType.split('-');
            let format = tokens.length > 0 ? tokens[tokens.length - 1] : '';
            return <DateResponseComponent format={format} response={response} />
        }
        else if (question.dataSource?.toLowerCase() === 'cls') {
            return <LicensingInfoComponent
                downLoadProviderDataByDataSource={downLoadProviderDataByDataSource}
                dataSource={question.dataSource} response={response}
            />

        }
        else if (question.dataSource?.toLowerCase() === DataSource.EIM ||
            question.dataSource?.toLowerCase() === DataSource.HRST ||
            question.dataSource?.toLowerCase() === DataSource.HCSIS
        ) {
            return <StateWideDataInfoComponent
                downLoadProviderDataByDataSource={downLoadProviderDataByDataSource}
                dataSource={question.dataSource} response={response || []}
            />
        }
        else if(question.dataFieldType === 'internal'){
            return <></>
        }
        else {
            return <DefaultResponseComponent questionText={question.questionDescription} response={response} />
        }
    }

    return (
        getResponseComponent(question.responseData)
    )
}

